import React from "react";

function UnansweredCall() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 58 53"
    >
      <g fill="none">
        <path
          fill="#e64c3c"
          d="M39.186 45.419l9.973 7.236c.719.522 1.71.444 2.339-.183l5.975-5.961c.555-.558.687-1.41.327-2.111C53.217 35.372 42.055 29 29 29S4.783 35.372.2 44.4c-.363.7-.231 1.555.325 2.115L6.5 52.472c.629.627 1.62.705 2.339.183l9.973-7.236a1.8 1.8 0 00.7-1.067l1.2-5.424c.18-.79.786-1.412 1.571-1.611a27.157 27.157 0 0113.42 0c.785.2 1.391.822 1.57 1.611l1.2 5.424a1.8 1.8 0 00.713 1.067z"
          data-original="#e64c3c"
        ></path>
        <path
          fill="#c03a2b"
          d="M48.758.138l-14 1.555a1 1 0 00-.6 1.7l4.1 4.1-9.385 9.385L13.076 2.831A3.074 3.074 0 009.2 2.6a3 3 0 00-.188 4.642l18 16a3 3 0 004.114-.121l11.38-11.385 4.1 4.1a1 1 0 001.7-.6l1.555-14A1 1 0 0048.758.138z"
          data-original="#c03a2b"
        ></path>
      </g>
    </svg>
  );
}

export default UnansweredCall;
